import { gql } from '__generated__';

export default gql(`
  mutation ActivateProduct($id: ID!) {
    activateProduct(id: $id) {
      id
      active
    }
  }
`);
